import React, { useState, useRef } from "react"
import styled from "styled-components"
import withApolloClient from "./withApolloClient"
import { ChevronDown, ChevronRight } from "@omnichannel/ace-b2b-elements"
import useOutsideAlerter from "../helpers/useOutsideAlerter"
import { navigate } from "gatsby"
import { formatString } from "../utils/utils"
import { useQuery } from "@apollo/react-hooks"
import SquareCard from "./cards/squareCard"
import FeaturedBrandsRow from "./featuredBrandsRow"
import gql from "graphql-tag"
import { APP_ID } from "../helpers/constants"
import noImage from "../images/no-image.png"

const trimText = (string) => {
  let charCount = 40
  if (string && string.length <= charCount) {
    return string
  }
  return `${string.substring(0, charCount)}...`
}

const MainRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 1rem;
`

const RowItem = styled.div`
  font-size: 1.5rem;
  color: #fff;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin: 0 2.6rem 0 0.5rem;
  @media (min-width: 961px) {
    margin: 0 3.5rem 0 0.5rem;
  }
`

const MenuContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 10.2rem;
  left: 0;
  z-index: 1000;
  opacity: 0.95;
  background-color: #fff;
  box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.2);
`

const MenuContent = styled.div`
  margin: auto;
  padding: 2rem 0;
  max-width: 140rem;
  display: flex;
  flex-direction: row;
`

const ItemRow = styled.div`
  cursor: pointer;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const SubItemRow = styled(ItemRow)`
  width: 25%;
  @media (min-width: 1024px) {
    width: 100%;
  }
`

const ItemLabel = styled.div`
  font-size: 1.4rem;
  font-weight: 400;
  color: ${props =>
    props.isSelected ? "#ef0a0a" : "#474747"};
  &:hover {
    color: ${props => "#ef0a0a"};
  }
`

const SubItemLabel = styled(ItemLabel)`
  /* color: ${props => props.theme[APP_ID].secondary}; */
  color: #ef0a0a;
  &:hover {
    color: #474747;
  }
`

const LeftBox = styled.div`
  display: flex;
  width: 30%;
  @media (min-width: 1024px) {
    width: 23%;
  }
`

const MainColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`

const RightSideBox = styled.div`
  display: flex;
  width: 72%;
  flex-direction: column;
  padding-right: 0.8rem;
  align-items: flex-start;
  justify-content: flex-start;
  @media (min-width: 1024px) {
    width: 75%;
    flex-direction: row;
    align-items: center;
  }
`

const SubColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 1024px) {
    flex-wrap: nowrap;
    flex-direction: column;
    width: 30%;
    align-self: flex-start;
  }
`

const ImageColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0;
  @media (min-width: 1024px) {
    width: 70%;
    // background-color: pink;
  }
`

const BrandColumn = styled(ImageColumn)`
  justify-content: space-between;
  width: 100%;
  @media (min-width: 961px) {
    justify-content: space-between;
  }
  @media (min-width: 1024px) {
    width: 100%;
    justify-content: center;
  }
`

// const Divider = styled.div`
//   height: auto;
//   border-left: 1px #F1F1F1 solid;
//   width: 2px;
// `

const ProductContainer = styled.div`
  // flex: 1;
  width: 33.3%;
  padding: 0.1rem 0.1rem;
  // max-width: 33.3%;
  overflow: hidden;
  &:hover {
    background-color: #ececec;
  }
`

const FeaturedBrands = styled.div`
  max-width: 75%;
  width: 100%;
`

const ViewAll = styled.div`
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  /* color: ${props => props.theme.default.primary}; */
  color: #ef0a0a;
  text-align: center;
  padding: .8rem 0 0 0;
`

const BrandProductContainer = styled(ProductContainer)`
  width: 23%;
  @media (min-width: 768px) {
    width: 33%;
  }
  @media (min-width: 961px) {
    width: 28%;
  }
  @media (min-width: 1024px) {
    width: 23%;
  }
`

const CategoryItem = ({ label, onClick, isMain, isSelected }) => {
  return (
    <ItemRow onClick={onClick}>
      <ItemLabel isSelected={isSelected}>{formatString(label)}</ItemLabel>
      {isMain && (
        <ChevronRight
          width={8}
          height={8}
          color={isSelected ? "#ef0a0a" : "#474747"}
        />
      )}
    </ItemRow>
  )
}

const SubCategoryItem = ({ label, onClick, isMain, isSelected }) => {
  return (
    <SubItemRow onClick={onClick}>
      <SubItemLabel isSelected={isSelected}>{formatString(label)}</SubItemLabel>
    </SubItemRow>
  )
}

const CategoryRow = ({ categories = [{}], brands = [] }) => {
  // console.log("categories::", categories)
  const [selectedCategory, setSelectedCategory] = useState(categories[0])
  const [categoryType, setCategoryType] = useState(null)
  const [children, setChildren] = useState([])
  const wrapperRef = useRef(null)

  const closeWindow = () => {
    setSelectedCategory(categories[0])
    setCategoryType(null)
  }

  useOutsideAlerter(wrapperRef, () => {
    closeWindow()
  })

  // const category = useStaticQuery(graphql`
  //   query HomeCategories {
  //     estore {
  //       categories {
  //         _id
  //         name
  //         children {
  //           _id
  //           name
  //         }
  //       }
  //       getHomepageBrands(limit: 10, isFeatured: true) {
  //         _id
  //         name
  //         base64
  //         order
  //       }
  //     }
  //   }
  // `)

  const { data, loading } = useQuery(
    gql`
      query randomProductImagesAndSkuByCategory(
        $mainCategory: String
        $limit: Int
      ) {
        randomProductImagesAndSkuByCategory(
          mainCategory: $mainCategory
          limit: $limit
        ) {
          image {
            _id
            base64_500
          }
          sku {
            _id
            commercialName
            productName
            isOOS
            discount
            referencePrice
            currentPrice
            rating
          }
        }
      }
    `,
    {
      variables: {
        mainCategory: selectedCategory !== null && selectedCategory._id,
        limit: 3,
      },
      skip: selectedCategory === null || categoryType !== "products",
    }
  )

  const { data: brandsData, loading: brandsLoading } = useQuery(
    gql`
      query randomProductImagesAndSkuByBrandId($brand: String, $limit: Int) {
        randomProductImagesAndSkuByBrandId(brand: $brand, limit: $limit) {
          image {
            _id
            base64_500
          }
          sku {
            _id
            commercialName
            productName
            isOOS
            discount
            referencePrice
            currentPrice
            rating
          }
        }
      }
    `,
    {
      variables: {
        brand: selectedCategory !== null && selectedCategory._id,
        limit: 3,
      },
      skip: selectedCategory === null || categoryType !== "brands",
    }
  )

  return (
    <>
      <MainRow>
        <RowItem
          onClick={() => {
            setCategoryType("products")
            setSelectedCategory({
              _id: selectedCategory._id,
              name: selectedCategory.name,
            })
            setChildren(selectedCategory.children)
          }}
        >
          Products&nbsp;
          <ChevronDown width={12} height={12} color={"#fff"} />
        </RowItem>
        <RowItem
          onClick={() => {
            setCategoryType("brands")
            setSelectedCategory({
              _id: brands[0]._id,
              name: brands[0].name,
            })
          }}
        >
          Brands&nbsp;
          <ChevronDown width={12} height={12} color={"#fff"} />
        </RowItem>
        <RowItem onClick={() => navigate("/stores")}>Store Locator</RowItem>
        <RowItem onClick={() => {
          sessionStorage.removeItem("What's New::scrollTo")
          navigate("/newarrival")
        }}>What's New</RowItem>
        <RowItem onClick={() => {
          sessionStorage.removeItem("On Sale::scrollTo")
          navigate("/sale")
        }}>Sale</RowItem>
      </MainRow>
      {categoryType && (
        <MenuContainer ref={wrapperRef}>
          {categoryType === "products" ? (
            <MenuContent>
              <LeftBox>
                <MainColumn>
                  {categories.map((category, index) => {
                    return (
                      <CategoryItem
                        key={index}
                        isSelected={
                          selectedCategory !== null &&
                          category.name === selectedCategory.name
                        }
                        label={category.name}
                        isMain
                        onClick={() => {
                          setChildren(category.children)
                          setSelectedCategory({
                            _id: category._id,
                            name: category.name,
                          })
                        }}
                      />
                    )
                  })}
                </MainColumn>
              </LeftBox>
              <RightSideBox>
                {selectedCategory && (
                  <SubColumn>
                    {children.map((category, index) => {
                      return (
                        <SubCategoryItem
                          key={index}
                          label={category.name}
                          onClick={() => {
                            sessionStorage.removeItem(`${selectedCategory.name}/${category.name}::scrollTo`)
                            navigate(
                              `/category/${selectedCategory.name}/${category.name}/`
                            )
                            closeWindow()
                          }}
                        />
                      )
                    })}
                  </SubColumn>
                )}
                {selectedCategory &&
                  !loading &&
                  data.randomProductImagesAndSkuByCategory.length > 0 ? (
                    <ImageColumn>
                      {data.randomProductImagesAndSkuByCategory.map(
                        (product, index) => {
                          return (
                            <ProductContainer key={index}>
                              <SquareCard
                                key={product.sku._id}
                                skuId={product.sku._id}
                                cardImgSrc={
                                  product.image
                                    ? product.image.base64_500
                                    : noImage
                                }
                                currentPrice={product.sku.currentPrice}
                                referencePrice={product.sku.referencePrice}
                                category={product.sku.brandName}
                                discount={product.sku.discount}
                                productName={trimText(product.sku.commercialName)}
                                rating={
                                  product.sku.rating !== "NaN"
                                    ? product.sku.rating
                                    : 0
                                }
                                onClick={() => {
                                  navigate("/product/" + product.sku._id)
                                  closeWindow()
                                }}
                                isSoldOut={product.sku.isOOS}
                              />
                            </ProductContainer>
                          )
                        }
                      )}
                    </ImageColumn>
                  ) : (
                    <ImageColumn />
                  )}
              </RightSideBox>
            </MenuContent>
          ) : (
              <MenuContent>
                <MainColumn>
                  {brands.map((brand, index) => {
                    return (
                      <CategoryItem
                        key={index}
                        isSelected={
                          selectedCategory !== null &&
                          brand.name === selectedCategory.name
                        }
                        label={brand.name}
                        onClick={() => {
                          setSelectedCategory({
                            _id: brand._id,
                            name: brand.name,
                          })
                          //navigate("/brand/" + brand.name)
                          //closeWindow()
                        }}
                      />
                    )
                  })}
                </MainColumn>
                <FeaturedBrands>
                  <FeaturedBrandsRow isHeader={true} />
                  {selectedCategory &&
                    !brandsLoading &&
                    brandsData.randomProductImagesAndSkuByBrandId.length > 0 ? (
                      <BrandColumn>
                        {brandsData.randomProductImagesAndSkuByBrandId.map(
                          (product, index) => {
                            return (
                              <BrandProductContainer key={index}>
                                <SquareCard
                                  key={product.sku._id}
                                  skuId={product.sku._id}
                                  cardImgSrc={
                                    product.image
                                      ? product.image.base64_500
                                      : noImage
                                  }
                                  currentPrice={product.sku.currentPrice}
                                  referencePrice={product.sku.referencePrice}
                                  category={product.sku.brandName}
                                  discount={product.sku.discount}
                                  productName={trimText(product.sku.commercialName)}
                                  rating={
                                    product.sku.rating !== "NaN"
                                      ? product.sku.rating
                                      : 0
                                  }
                                  onClick={() => {
                                    navigate("/product/" + product.sku._id)
                                    closeWindow()
                                  }}
                                  isSoldOut={product.sku.isOOS}
                                />
                              </BrandProductContainer>
                            )
                          }
                        )}
                      </BrandColumn>
                    ) : (
                      <BrandColumn />
                    )}
                  <ViewAll
                    onClick={() => {
                      sessionStorage.removeItem(`${selectedCategory.name}::scrollTo`)
                      navigate("/brand/" + selectedCategory.name)
                      closeWindow()
                    }}
                  >
                    Show All {selectedCategory.name} {'>'}
                  </ViewAll>
                </FeaturedBrands>
              </MenuContent>
            )}
        </MenuContainer>
      )}
    </>
  )
}

export default withApolloClient(CategoryRow, { client: "smClient" })
